/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { RouteConfig } from 'vue-router';
import { ifAuthenticated } from '../routeValidation';
import { commpixIntegrations, masspaymentIntegrations, mantecaIntegrations, pvsIntegrations } from './permissions';
import { ROUTES } from './routes';
import { NAVBAR_TYPE_LIGHT } from '@/util/constants/config';

const { INTEGRATIONS_COMMPIX, INTEGRATIONS_MASSPAYMENTS, INTEGRATIONS_MANTECA, INTEGRATIONS_PVS, } = ROUTES;

const Commpix = () =>
  import(
    /* webpackChunkName: "Integrations" */
    '@/views/Integrations/Commpix.vue'
  );

const MassPayment = () =>
  import(
    '@/views/Integrations/MassPayments.vue'
  );

const Manteca = () =>
  import(
    '@/views/Integrations/Manteca.vue'
  );

const Pvs = () =>
  import(
    '@/views/Integrations/Pvs.vue'
  );

const integrationRoute: RouteConfig = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: INTEGRATIONS_COMMPIX.route,
      name: INTEGRATIONS_COMMPIX.name,
      component: Commpix,
      beforeEnter: ifAuthenticated,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: commpixIntegrations,
      },
    },
    {
      path: INTEGRATIONS_MASSPAYMENTS.route,
      name: INTEGRATIONS_MASSPAYMENTS.name,
      component: MassPayment,
      beforeEnter: ifAuthenticated,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: masspaymentIntegrations,
      },
    },
    {
      path: INTEGRATIONS_MANTECA.route,
      name: INTEGRATIONS_MANTECA.name,
      component: Manteca,
      beforeEnter: ifAuthenticated,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: mantecaIntegrations,
      },
    },
    {
      path: INTEGRATIONS_PVS.route,
      name: INTEGRATIONS_PVS.name,
      component: Pvs,
      beforeEnter: ifAuthenticated,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: pvsIntegrations,
      },
    }
  ],
};
export default integrationRoute;
